/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');

import VueAwesomeSwiper from 'vue-awesome-swiper';
Vue.use(VueAwesomeSwiper, {
    spaceBetween: 0,
    centeredSlides: true,
    speed: 800,
    autoplay: {
        delay: 5000,
        disableOnInteraction: false
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    }
});

Vue.directive('has-error', require('../admin/directives/has-error.vue').default);
Vue.directive('square', require('./directives/square.js').default);
Vue.directive('ratio', require('./directives/ratio.js').default);
Vue.directive('same', require('./directives/same.js').default);
Vue.directive('load-img', require('./directives/load-img.js').default);

Vue.component('spinner', require('../admin/shared/spinner.vue').default);
Vue.component('contact', require('./contact.vue').default);
Vue.component('donate-popup', require('./donate-popup.vue').default);
Vue.component('blog', require('./blog.vue').default);
Vue.component('gallery', require('./gallery.vue').default);
Vue.component('image-modal', require('./image-modal.vue').default);
Vue.component('modal', require('./modal.vue').default);

const app = new Vue({
    el: '#app',
    data() {
        return {
            toggle: false,
        }
    },
});
